export const BRIEFING_PILLAR_ORDER = [
  "street_narrative_vs_reality",
  "capital_allocation_and_efficiency",
  "competitive_moat",
  "elephant_in_the_room",
] as const;

export const BRIEFING_SUBSECTION_ORDER: Record<string, readonly string[]> = {
  street_narrative_vs_reality: [
    "consensus_bull_case",
    "consensus_bear_case",
    "under_the_radar_risks_opportunities",
  ],
  capital_allocation_and_efficiency: [
    "track_record_evaluation",
    "roic_vs_wacc_analysis",
    "killer_question",
  ],
  competitive_moat: [
    "pricing_power_and_stickiness",
    "customer_alternative_scenario",
    "specific_24_month_threat",
  ],
  elephant_in_the_room: ["uncomfortable_question", "context_and_rationale"],
};
